import { useContext, useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { ArrowCircleRightSharp, FiberManualRecord, DirectionsBike } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import ConnUrls from "../../Connections/ConnectURL";
import { MasterContext, MobiOrNotContext } from "../../ContextApi/context";
import MyDateTime from "../../DTechComp/MyDateTime";
import MySpinner_Wait from "../../DTechComp/MySpinner_Wait";
import ScrollingSaver from "../../DTechComp/ScrollingSaver";
import SearchComp from "../../DTechComp/Search";
import utilsRests from "../../_Utils/utilsRests";
import myFunctions from "../../myFunctions";
import SearchComp2 from "../../DTechComp/Search2";
import { Helmet } from "react-helmet";
import useNotDelivering from '../../DTechComp/useNotDelivering';
import { CityContext } from '../../ContextApi/cityContext';
import WaitImgOverlay from '../../DTechComp/WaitImgOverlay';



const SearchP = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const notDeliveringTxt = useNotDelivering();
    // המקום והעיר של הלקוח - השרת מסנן את התוצאות לפיהם; בהחלפה - חיפוש מחדש
    const { cityId, myCity } = useContext(CityContext);
    const placeKey = (cityId || "") + "_" + (myCity ? myCity._id : "");

    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [initialLoad, setInitialLoad] = useState(true);
    const [searchLoading, setSearchLoading] = useState(false);
    const [shufMe, setShufMe] = useState([]);
    const [displayedItems, setDisplayedItems] = useState(16);
    const [srchTxt, setSrchTxt] = useState("");
    const history = useHistory();
    const location = useLocation();
    const [bgImgPos, setBgImgPos] = useState("");
    const [waitImgItm, setWaitImgItm] = useState({});
    const searchInputRef = useRef(null);
    const searchTimerRef = useRef(null);
    const [searchSchema, setSearchSchema] = useState("");
    const [breadcrumbSchema, setBreadcrumbSchema] = useState("");
    const hasAutoFocused = useRef(false);
    const [localSearchTxt, setLocalSearchTxt] = useState("");

    let shuffClosed = [];

    useEffect(() => {
        // props.scrollToTop();

        props.shoTopStrp(false)

        setWaitImgItm(myFunctions.setTheImgWait(myFunctions.searchWaitPage(master), master, mobiOrNot));

        getSearchresault();
    }, [])

    // Focus on search input only once on initial page load
    useEffect(() => {
        if (!initialLoad && !hasAutoFocused.current && searchInputRef.current) {
            searchInputRef.current.focus();
            hasAutoFocused.current = true;
        }
    }, [initialLoad])

    // Sync localSearchTxt with URL parameter on mount and URL changes
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const searchTerm = queryParams.get('txSrch');
        if (searchTerm) {
            setLocalSearchTxt(searchTerm);
        }
    }, [location.search])

    // Listen to URL changes for search updates
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const searchTerm = queryParams.get('txSrch');
        if (searchTerm) {
            getSearchresault();
        }
    }, [location.search, placeKey])

    // Update schema when search results change
    useEffect(() => {
        if (srchTxt) {
            createSearchSchema();
            createBreadcrumbSchema();
        }
    }, [srchTxt, shufMe])

    // Lazy loading on scroll
    useEffect(() => {
        const handleScroll = () => {
            if (searchLoading || displayedItems >= shufMe.length) return;

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = window.innerHeight;

            if (scrollTop + clientHeight >= scrollHeight - 1200) {
                setDisplayedItems(prev => Math.min(prev + 16, shufMe.length));
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [searchLoading, displayedItems, shufMe.length])

    const goToBack = () => {
        history.goBack();

        // if (document.referrer.indexOf(window.location.host) === -1) {
        // }
        // else {
        //      history.push('/'); }
    }

    const getSearchresault = async () => {
        const queryParams = new URLSearchParams(location.search);
        const searchTerm = queryParams.get('txSrch');
        setSrchTxt(searchTerm || "")
        setLocalSearchTxt(searchTerm || "")

        if (!searchTerm || searchTerm.trim() === "") {
            setShufMe([])
            setInitialLoad(false)
            return;
        }

        setSearchLoading(true)
        let allOnSearch = await utilsRests.getSerchResault(searchTerm);
        setShufMe(allOnSearch || [])
        setDisplayedItems(16)

        setWaitImgItm(myFunctions.setTheImgWait(myFunctions.searchWaitPage(master), master, mobiOrNot));
        setSearchLoading(false)
        setInitialLoad(false)

        // חיפוש "התממש" - הגיע לעמוד תוצאות עם מונח אמיתי - נרשם פעם אחת
        // לסטטיסטיקה, בניגוד לקריאות ה-debounce התכופות בתיבת ההקלדה עצמה
        utilsRests.logSearchTerm(searchTerm);
    }

    const serachBuis = (txtSearch) => {
        history.push("/search/?txSrch=" + encodeURIComponent(txtSearch));
    }

    const handleSearchInput = (searchText) => {
        setLocalSearchTxt(searchText);
        setSrchTxt(searchText);
        
        // Clear previous timer
        clearTimeout(searchTimerRef.current);
        
        // If less than 2 characters, clear results
        if (searchText.trim().length < 2) {
            setShufMe([]);
            setDisplayedItems(16);
            setSearchLoading(false);
            return;
        }
        
        // Show loading indicator immediately
        setSearchLoading(true);
        
        // Wait 500ms after user stops typing
        searchTimerRef.current = setTimeout(async () => {
            let allOnSearch = await utilsRests.getSerchResault(searchText);
            setShufMe(allOnSearch || []);
            setDisplayedItems(16);
            setWaitImgItm(myFunctions.setTheImgWait(myFunctions.searchWaitPage(master), master, mobiOrNot));
            setSearchLoading(false);
        }, 500);
    }

    const createSearchSchema = () => {
        const schema = {
            "@context": "https://schema.org",
            "@type": "SearchResultsPage",
            "name": `תוצאות חיפוש: ${srchTxt}`,
            "description": shufMe.length > 0 
                ? `נמצאו ${shufMe.length} עסקים עבור החיפוש "${srchTxt}"`
                : `לא נמצאו תוצאות עבור החיפוש "${srchTxt}"`,
            "url": `${ConnUrls.siteDomainNam}/search/?txSrch=${encodeURIComponent(srchTxt)}`
        };
        setSearchSchema(JSON.stringify(schema));
    }

    const createBreadcrumbSchema = () => {
        const breadcrumb = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "דף הבית",
                    "item": ConnUrls.siteDomainNam
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": `חיפוש: ${srchTxt}`,
                    "item": `${ConnUrls.siteDomainNam}/search/?txSrch=${encodeURIComponent(srchTxt)}`
                }
            ]
        };
        setBreadcrumbSchema(JSON.stringify(breadcrumb));
    }

    //chans = הפלט של resolveBusinessChannels.
    //הנקודה והטקסט לפי chans.business (שעות הפתיחה),
    //הרצועה והמיון לפי canOrderNow
    const setOpenItem = (item, index, chans) => {
        let opHours = chans.business;
        let notGettinOrders = myFunctions.notGettinOrders(master, item, chans);

        let timing = (item.Delivery?.Time) ? item.Delivery.Time : (item.TakeAway?.Time) ? item.TakeAway.Time : 30;
        let timingChannel = (item.Delivery?.Time) ? "Deliver" : "Take";
        timing = myFunctions.checkForDeliverysDelay(master, timing, timingChannel);

        // Check if txtBuisKosher contains "כשר" or "כשרות", and remove them.
        // If after removal there's no other content, don't render the block.
        const kosherText = item.txtBuisKosher;

        // Mobile view - compact dropdown style
        if (mobiOrNot) {
            return (
                <Link key={index} to={{
                    pathname: `/restaurants/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`,
                    state: { waitImg: item.waitingImg }
                }}
                    className="mobile-search-item"
                >
                    <div className="mobile-search-item-content">
                        <img className={'mobile-search-thumb'} src={ConnUrls.media(item.buissMainImg)} alt={item.buissName} />
                        <div className="mobile-search-details">
                            <span className="mobile-search-name">{item.buissName}</span>
                            
                            <div className="mobile-search-info">
                                <div className="mobile-search-hours">
                                    <span className={`specDot ${!opHours.openOrCLose ? "specDotClose" : ""}`}>
                                        <FiberManualRecord style={{ fontSize: '12px' }} />
                                    </span>
                                    <span className="mobile-search-status">
                                        {opHours.openOrCLose ? opHours.timtxt : opHours.txtBtn}
                                    </span>
                                </div>
                                {/* עסק שלא שולח לעיר שהלקוח בחר - התגית במקום זמן המשלוח */}
                                {notDeliveringTxt(item)
                                    ? <span className="notDelivTag">{notDeliveringTxt(item)}</span>
                                    : <div className="mobile-search-delivery">
                                        <DirectionsBike style={{ fontSize: '16px', transform: 'scaleX(-1)' }} />
                                        <span className="mobile-search-time">
                                            {parseInt(timing)} - {(parseInt(timing) + 10)} דק'
                                        </span>
                                    </div>}
                            </div>

                            {item.matchReason && item.matchReason !== 'keyword' && (
                                <div className="mobile-search-match">
                                    {item.matchReason === 'name' && <div>⭐ העסק: {item.buissName}</div>}
                                    {item.matchReason === 'menu' && <div>🏷️ קטגוריה: {item.matchText}</div>}
                                    {item.matchReason === 'product' && <div>🍴 מנה: {item.matchText}</div>}
                                    {item.matchReason === 'supermarket-menu' && <div>🏷️ קטגוריה: {item.matchText}</div>}
                                    {item.matchReason === 'supermarket-product' && <div>🛒 מוצר: {item.matchText}</div>}
                                </div>
                            )}
                        </div>
                    </div>
                </Link>
            );
        }

        // Desktop view - original card style
        return (
            <div key={index} className={"Hprest animate__animated pulseME"}>
                <Link to={{
                    pathname: `/restaurants/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`,
                    state: { waitImg: item.waitingImg }
                }}>
                    <div className={"imgWrap"}>
                        <div className={"imgDiv"} style={{ backgroundImage: `url("${ConnUrls.media(item.buissMainImg)}")` }} >
                            {item.matchReason && item.matchReason !== 'name' && (
                                <div style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    backgroundColor: '#fec000',
                                    color: '#333',
                                    padding: '8px 14px',
                                    borderRadius: '20px',
                                    fontSize: '0.9em',
                                    fontWeight: 'bold',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                    zIndex: 10
                                }}>
                                    {item.matchReason === 'menu' && `🏷️ ${item.matchText}`}
                                    {item.matchReason === 'product' && `🍴 ${item.matchText}`}
                                    {item.matchReason === 'supermarket-menu' && `🏷️ ${item.matchText}`}
                                    {item.matchReason === 'supermarket-product' && `🛒 ${item.matchText}`}
                                    {item.matchReason === 'keyword' && `🔍 חיפוש`}
                                </div>
                            )}

                            <div className={"botBlock"}>
                                {(notGettinOrders != "") ?
                                    <div data-nosnippet className={"imgWrapDivClose no-render"}>
                                        <span data-nosnippet className={"no-render"}>{notGettinOrders}</span>
                                    </div> : ""}
                                <div className={"width_96"}>

                                    <div className={"fullRow overflowHid dottedLine_2"}>
                                        <div className={"smBlockHead pgBigTxt bold big spacePadBig onRight"}>{item.buissName}</div>
                                        {kosherText !== "" &&
                                            <div className={"txtBuisKosher_Block onLeft"}>{kosherText}</div>
                                        }
                                    </div>
                                    <div className={"fullRow fullRowflex"}>
                                        <div className={"pgSmallTxt regular grayText"}>
                                            <p>{item.buissKitchType}</p>
                                        </div>
                                        <div className={"pgSmallTxt"}>
                                            <p className={"pgOpenCloseBlk mediumst"}>
                                                <span className={`specDot ${!opHours.openOrCLose ? "specDotClose" : ""}`}><FiberManualRecord /></span>
                                                <span className={"grayText"}>{opHours.openOrCLose ? opHours.timtxt : opHours.txtBtn}</span>
                                            </p>
                                        </div>
                                        {notDeliveringTxt(item)
                                            ? <div className={"pgSmallTxt"}><span className={"notDelivTag"}>{notDeliveringTxt(item)}</span></div>
                                            : <div className={"pgSmallTxt inFlex"}>
                                                <div className={"theImgwrap"} >
                                                    <div className={"theImg  spaceRight"} >
                                                        <DirectionsBike />
                                                    </div>
                                                </div>
                                                <div className={"timeTxt mediumst spaceRight spacePad grayText"}>
                                                    {(parseInt(timing) + 10) +
                                                        " - " + parseInt(timing)} דק'
                                                </div>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }


    return (

        // <div className={loading ? "imgWaiting" : `imgWaiting animate__animated animate__fast animate__zoomOut ${master.imgDelay}`}>
        //     <img src={`${ConnUrls.media(master.waitingImgMaster)}`} />
        // </div>
        <div className="CateguryPage">

            {initialLoad && <WaitImgOverlay item={waitImgItm} noExit />}

            {!initialLoad && (
                <>
                    <div className={"headOnFixC SecondFont bold big"}>

                        <div>{`חיפוש ${srchTxt ? `"${srchTxt}"` : ""}`}</div>
                        <div className={`backSdOnlyBtn`}>
                            <ArrowCircleRightSharp onClick={() => goToBack()} />
                        </div>
                    </div>

                    <br /><br /><br /><br />
                    <div className={"fullRow overflowHid"}>
                        {!mobiOrNot && (
                            <div className={"onRight fullRow"}>
                                <div className={"pagHead bold big"}>{`חיפוש ${srchTxt ? `"${srchTxt}"` : ""}`}</div>
                            </div>
                        )}
                        <div className={mobiOrNot ? "width_90" : "onRight"}>
                            <div className={"srchDskTop"}>
                                <SearchComp2 
                                    ref={searchInputRef} 
                                    value={localSearchTxt}
                                    pHolder={"חפש שם עסק, מנה או פריט"} 
                                    srchFunc={(txtSrch) => serachBuis(txtSrch)} 
                                    onSearchChange={(txtSrch) => handleSearchInput(txtSrch)}
                                    showDropdown={false} 
                                />
                            </div>
                        </div>
                    </div>
                    <br />

                    {searchLoading && (
                        <div style={{ textAlign: 'center', padding: '20px', fontSize: '1.1em', color: '#333', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                            <CircularProgress size={20} style={{ color: '#333' }} />
                            <span>מחפש...</span>
                        </div>
                    )}

                    {(!srchTxt || srchTxt.trim() === "") ? (
                        <div style={{ textAlign: 'center', padding: '40px', fontSize: '1.2em', color: '#666' }}>
                            <p>הזן מילת חיפוש למעלה</p>
                        </div>
                    ) : shufMe.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '40px', fontSize: '1.2em', color: '#666' }}>
                            <p>לא נמצאו תוצאות עבור "{srchTxt}"</p>
                            <p style={{ fontSize: '0.9em', marginTop: '10px' }}>נסה לחפש משהו אחר</p>
                        </div>
                    ) : (
                        <>
                            {shufMe.slice(0, displayedItems).map((item, index) => {

                                let chans = MyDateTime.resolveBusinessChannels(item, master);
                                //המיון לפי "אפשר להזמין" ולא לפי שעות הפתיחה
                                if (chans.canOrderNow) {
                                    return (setOpenItem(item, index, chans))
                                }
                                else {
                                    shuffClosed.push({ item, index, chans });
                                }
                            })}

                            {shuffClosed.slice(0, Math.max(0, displayedItems - (shufMe.slice(0, displayedItems).length - shuffClosed.length))).map((item) => {

                                return (setOpenItem(item.item, item.index, item.chans))
                            })}

                            {displayedItems < shufMe.length && (
                                <div style={{ textAlign: 'center', padding: '20px', fontSize: '1.1em', color: '#666' }}>
                                    גלול לעוד תוצאות...
                                </div>
                            )}

                        </>
                    )}


                    <ScrollingSaver pagNam={"searchP_" + srchTxt} contentReady={!initialLoad} />
                </>
            )}

            <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/search/?txSrch=${encodeURIComponent(srchTxt)}`
                    }
                ]}>
                <link rel="canonical" href={srchTxt ? `${ConnUrls.siteDomainNam}/search/?txSrch=${encodeURIComponent(srchTxt)}` : `${ConnUrls.siteDomainNam}/search`} />
                {searchSchema && <script type="application/ld+json">{searchSchema}</script>}
                {breadcrumbSchema && <script type="application/ld+json">{breadcrumbSchema}</script>}
            </Helmet>

        </div>
    )
}




export default SearchP;